interface CloudWithSchemeSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CloudWithSchemeSVG = ({ color, style }: CloudWithSchemeSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="46"
    height="50"
    viewBox="0 0 46 50"
    fill="none"
  >
    <g clipPath="url(#clip0_465_13726)">
      <path
        d="M8.45483 29.7122C4.09745 29.7122 0.55957 26.1743 0.55957 21.8169C0.55957 17.4596 4.09745 13.9217 8.45483 13.9217C8.55477 13.9217 8.65471 13.9317 8.76465 13.9417C8.59475 13.1821 8.5048 12.3926 8.5048 11.5831C8.5048 5.48674 13.4318 0.559692 19.5182 0.559692C24.4652 0.559692 28.6527 3.82773 30.0419 8.32503C31.2012 7.91528 32.4404 7.68542 33.7397 7.68542C39.826 7.68542 44.7531 12.6225 44.7531 18.6988C44.7531 24.7752 40.1858 29.3424 34.4292 29.6922L8.44484 29.7122H8.45483Z"
        stroke={color}
        strokeWidth="1.11933"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75608 43.8737H3.91778C3.16712 43.8737 2.55859 44.4822 2.55859 45.2328V48.0711C2.55859 48.8218 3.16712 49.4303 3.91778 49.4303H6.75608C7.50673 49.4303 8.11526 48.8218 8.11526 48.0711V45.2328C8.11526 44.4822 7.50673 43.8737 6.75608 43.8737Z"
        stroke={color}
        strokeWidth="1.11933"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0754 43.8737H21.2371C20.4865 43.8737 19.8779 44.4822 19.8779 45.2328V48.0711C19.8779 48.8218 20.4865 49.4303 21.2371 49.4303H24.0754C24.8261 49.4303 25.4346 48.8218 25.4346 48.0711V45.2328C25.4346 44.4822 24.8261 43.8737 24.0754 43.8737Z"
        stroke={color}
        strokeWidth="1.11933"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.405 43.8737H38.5667C37.816 43.8737 37.2075 44.4822 37.2075 45.2328V48.0711C37.2075 48.8218 37.816 49.4303 38.5667 49.4303H41.405C42.1557 49.4303 42.7642 48.8218 42.7642 48.0711V45.2328C42.7642 44.4822 42.1557 43.8737 41.405 43.8737Z"
        stroke={color}
        strokeWidth="1.11933"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6572 29.7122V35.5387"
        stroke={color}
        strokeWidth="1.11933"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6572 43.8736V35.5386"
        stroke={color}
        strokeWidth="1.11933"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.9861 43.8736V38.9965C39.9861 37.1776 38.507 35.6985 36.6881 35.6985H8.63494C6.81603 35.6985 5.33691 37.1776 5.33691 38.9965V43.8736"
        stroke={color}
        strokeWidth="1.11933"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_465_13726">
        <rect width="45.3228" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default CloudWithSchemeSVG;
